import { inject, Pipe, PipeTransform } from '@angular/core';
import { TextTranslationService } from '@core/text/text-translation.service';

@Pipe({ name: 'translate' })
export class TranslatePipe implements PipeTransform {
  translationService = inject(TextTranslationService);

  transform(value: string | undefined): string {
    if (!value) {
      return '';
    }
    return this.translationService.translate(value);
  }
}
